<template lang="pug">
  div(v-cloak)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {}
  },
  created () {
    if (process.env.AUTH_STORATEGY !== 'account') {
      this.$router.push({ name: `${process.env.AUTH_STORATEGY}_signin` })
      return true
    }
    if (this.isAuthenticated) {
      this.$router.push({ name: 'dispatch' })
      return true
    }
    this.authorize()
  },
  computed: {
    ...mapGetters('common/account', ['isAuthenticated'])
  },
  methods: {
    ...mapActions('common/account', ['authorize'])
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/pages/Account/SignIn/index.vue